import React, { useState, useContext } from "react";
import { useGtfsRoutes, useQueryGtfsResource } from "../../Queries";
import { classNames } from 'primereact/utils';
import { ProgressSpinner } from "primereact/progressspinner";
import { VirtualScroller } from "primereact/virtualscroller";
import { RouteName } from "../../components/RouteName";
import { InputFilter } from "../../components/InputFilter";
import { RouteTypeIndicator } from "../../components/RouteTypeIndicator";
import { RoutePropertyEditor } from "./RoutePropertyEditor";
import { ToolsContext, ToolsDispatchContext } from "../../ToolsContext";
import { Button } from "primereact/button";
import { NewRouteDialog } from "./NewRouteDialog";




export function RoutePicker() {
    const { isPending, error, data } = useQueryGtfsResource('routes');
    const [filterText, setFilterText] = useState('');

    let GRoute = data;

    if (isPending) {
        return (
            <ProgressSpinner className="flex justify-content-center"/>
        );
    }

    if (error) {
        return (
            <>
                <i className="fa-solid fa-face-frown fa-5x"></i><br />
                Wystąpił błąd ładowania linii: {error.message}
            </>
        )
    }

    return (
        <>
            <InputFilter filterText={filterText} onFilterTextChange={setFilterText} placeholder='Znajdź linię' />
            <RouteList filterText={filterText} GRoute={GRoute} />
            <RouteBottomPanel />
        </> 
    )
}

function RouteList({filterText}) {
    const {isPending, error, data: GRoutes} = useQueryGtfsResource('routes');
    const tool = useContext(ToolsContext);
    const dispatch = useContext(ToolsDispatchContext);
    const items = [];
    
    if (isPending || !GRoutes) {
        return (
            <ProgressSpinner />
        );
    }

    Object.entries(GRoutes).forEach(([key, element]) => {
        if (String(element.route_short_name).toLowerCase().indexOf(
                filterText.toLowerCase()
            ) === -1 &&
            element.route_id.toLowerCase().indexOf(
                filterText.toLowerCase()
            ) === -1 && 
            element.route_long_name.toLowerCase().indexOf(
                filterText.toLowerCase()          
            ) === -1) {
            return;
        }
        items.push(element);
    });

    const itemTemplate = (item, options) => {
        const className = classNames('flex align-items-center gap-1 hover:text-orange-700 cursor-pointer align-items-center p-2', {
            'surface-hover': options.odd
        });

        return (
            <div
                key={item.route_id} 
                style={{
                    height: options.props.itemSize + 'px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                }}
                className={className}
                onDoubleClick={() => {
                    dispatch({
                        type: 'changed',
                        newTool: {
                            ...tool,
                            selection: item.route_id, // zaznacz trasę
                            propertyEditor: {   // i wyświetl w edytorze
                                edit: item
                            }
                        }
                    })
                }}
            >
                <RouteTypeIndicator GRoute={item}/>
                { (item.route_short_name) ? <RouteName GRoute={item}  /> : <></> }
                <div className="text-sm">
                    { (item.route_short_name) ? <b>{item.route_long_name}</b> : <b className='hover:text-orange-700' style={{display: "inline-block", fontWeight: "normal", backgroundColor: '#'+item.route_color, color: '#'+item.route_text_color, borderStyle: 'solid', borderWidth: '0.5pt', padding:'2px', borderColor: '#'+item.route_text_color}}>{item.route_long_name}</b> }
                    { (item.suspended) ? <span className="text-red-200"> zawieszona </span> : <></> }
                    <br />
                    <span className="text-200">{item.network_id}</span>
                </div>
            </div>
        )
    }

    return (
        <>
            <VirtualScroller items={items} itemSize={55} itemTemplate={itemTemplate} showLoader className="border-1 surface-border border-round w-full" style={{height: '92%'}} />
        </>
    );
}

function RouteBottomPanel() {
    const [dialogVisible,setDialogVisible] = useState(false);

    return (
        <div className="w-full p-3" style={{height: '3%'}}>
            <Button severity="success" icon="fa-solid fa-plus" label="Dodaj nową linię" outlined onClick={() => {setDialogVisible(true)}}></Button>
            <NewRouteDialog 
                visible={dialogVisible}
                onHide={() => {if (!dialogVisible) return; setDialogVisible(false); }}      
            />
        </div>
    )
}

